export default {
    transferList: {
        selectBytTasks: "Select individual tasks",
        byt: "individual",
        selectPromTasks: "Select industrial tasks",
        prom: "industrial",
        selectAll: "Select All",
        noSelectedElementsOperationError: "Cannot perform operation without item selection",
        unselect: "Unselect",
    }
}